module.exports = __webpack_public_path__ + "img/google-pay.330f1bef.svg";